module.exports = __webpack_public_path__ + "static/shobayo-02bfeec6d6080bd8589df91a146efe9f.png";